import React from "react";
import { LoaderStyled } from "./LoaderElements";

const Loader = () => {
  return (
    <LoaderStyled>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </LoaderStyled>
  );
};

export default Loader;
